const ITEMS = [
  "Pulizia con Drone",
  "+35% Resa Energetica",
  "Zero Ponteggi",
  "Acqua Osmotizzata",
  "Da 3 a 60 kW",
  "Pagamento Online Sicuro",
];

export function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative overflow-hidden border-y border-white/10 bg-[#0D0E13] py-5" data-testid="editorial-marquee">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display font-semibold uppercase tracking-wide text-2xl sm:text-3xl text-slate-200 px-6">
                  {item}
                </span>
                <span className="fire-text font-display text-2xl sm:text-3xl px-2">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
